// extracted by mini-css-extract-plugin
export default {"root":"MenuItem_root__OT+O9"};